module.exports = __webpack_public_path__ + "img/logo.c261bbd3.png";